export const LOCK_PROVIDERS = Object.freeze({
  SALTO_KS: 'saltolock',
  FUTUREHOME: 'futurehome',
  DANALOCK: 'danalock',
  NIMLY: 'nimly',
  SALTO_SPACE: 'saltoSpace',
  VISIONLINE: 'visionline',
  ARX: 'arx'
});

/** Providers whose native SDK scans for the lock and pushes discovery events. */
export const SCANNING_BLUETOOTH_PROVIDERS: readonly string[] = ['danalock', 'futurehome', 'nimly'];
/** Providers whose unlock runs in the native app's own modal (bottom sheet / card flip). */
export const LOCK_MODAL_PROVIDERS: readonly string[] = ['saltolock', 'saltoSpace', 'visionline'];
export const ARX_PROVIDERS: readonly string[] = ['arx'];

export const isScanningBluetoothProvider = (providerName: string | null | undefined): boolean =>
  SCANNING_BLUETOOTH_PROVIDERS.includes(providerName ?? '');
export const isLockModalProvider = (providerName: string | null | undefined): boolean =>
  LOCK_MODAL_PROVIDERS.includes(providerName ?? '');
export const isArxProvider = (providerName: string | null | undefined): boolean =>
  ARX_PROVIDERS.includes(providerName ?? '');
